
import { getCommonHead } from "@/utils/head"
import topContent from "@/components/topContent/topContent"
export default {
  components: {
    topContent
  },
  head() {
    return getCommonHead()
  }
}
